import type {
  ReceivablesControllerGetDownpaymentsData,
  ReceivablesControllerGetItemsData,
  ReceivablesControllerGetWriteOffsData,
  ReceivablesDownpaymentsDto,
  ReceivablesItemsDto,
  ReceivablesProblemsDto,
  ReceivablesSummaryDto,
  ReceivablesWriteOffsDto,
} from '@carvia/ros-client-types';
import { Service } from './http-service';

class ReceivablesService extends Service {
  async getSummary(
    params?: Pick<
      NonNullable<ReceivablesControllerGetItemsData['query']>,
      'invoiceTypes' | 'hasPeriodicInvoicing' | 'isDeposit' | 'search' | 'legalEntityId'
    >,
  ) {
    const res = await this.httpClient.get<ReceivablesSummaryDto>(`${this.endpoint}/summary`, {
      params,
    });
    return res.data;
  }

  async getItems(params: ReceivablesControllerGetItemsData['query']) {
    const res = await this.httpClient.get<ReceivablesItemsDto>(`${this.endpoint}/items`, {
      params,
    });
    return res.data;
  }

  async getProblems(legalEntityId?: string) {
    const res = await this.httpClient.get<ReceivablesProblemsDto>(`${this.endpoint}/problems`, {
      params: { legalEntityId },
    });
    return res.data;
  }

  async getDownpayments(params?: ReceivablesControllerGetDownpaymentsData['query']) {
    const res = await this.httpClient.get<ReceivablesDownpaymentsDto>(
      `${this.endpoint}/downpayments`,
      { params },
    );
    return res.data;
  }

  async getWriteOffs(params: ReceivablesControllerGetWriteOffsData['query']) {
    const res = await this.httpClient.get<ReceivablesWriteOffsDto>(`${this.endpoint}/write-offs`, {
      params,
    });
    return res.data;
  }

  async exportWriteOffsCsv(params: ReceivablesControllerGetWriteOffsData['query']) {
    const res = await this.httpClient.get<string>(`${this.endpoint}/write-offs/export`, {
      params,
    });
    return res.data;
  }
}

export const receivablesService = new ReceivablesService('/receivables');
